import React from "react";
import { renderMarkup } from "react-render-markup";
import SearchPropertyMessage from "./SearchPropertyMessage.js";

const Message = ({ message, actionBtnClick, axios }) => {
    return (
        <React.Fragment>
            <div
                className={
                    "chatbox-message " +
                    (message.is_user ? "ms-self" : "ms-support") +
                    (message.hasOwnProperty("is_error") && message.is_error
                        ? " ms-error"
                        : "") +
                    (message.hasOwnProperty("is_loading") && message.is_loading
                        ? " ms-loading"
                        : "")
                }
                data-id={message.id}
            >
                <div
                    className={
                        "message-text" +
                        (message.prompt && message.prompt == "search_property"
                            ? " w-100"
                            : "")
                    }
                >
                    {message.message && message.message.length ? (
                        <div className="message">
                            {renderMarkup(message.message, {
                                allowed: ["strong", "b", "a", "ul", "li", "ol"],
                            })}
                        </div>
                    ) : null}
                    {message.prompt && message.prompt == "search_property" ? (
                        <SearchPropertyMessage
                            message={message}
                            axios={axios}
                        />
                    ) : null}
                    {message.actions && message.actions.length ? (
                        <div className="message-actions">
                            {message.actions.map((action, i) => {
                                if (
                                    action.element_type &&
                                    action.element_type == "button"
                                ) {
                                    return (
                                        <button
                                            key={i}
                                            className={"btn btn-white"}
                                            onClick={() =>
                                                actionBtnClick(action)
                                            }
                                        >
                                            {action.message == "back" ? (
                                                <i className="fas fa-reply mr-h"></i>
                                            ) : null}
                                            {action.message_print}
                                        </button>
                                    );
                                }
                                if (
                                    action.element_type &&
                                    action.element_type == "link"
                                ) {
                                    return (
                                        <a
                                            key={i}
                                            className={"btn btn-white"}
                                            target="_blank"
                                            href={action.data.link}
                                        >
                                            {action.message_print} 
                                            <i className="fas fa-external-link-alt"></i>
                                        </a>
                                    );
                                }
                            })}
                        </div>
                    ) : null}
                </div>
                <div className="message-time">
                    {message.date.format("H:mm")}
                </div>
            </div>
        </React.Fragment>
    );
};

export default Message;
